import { render, staticRenderFns } from "./applicationList.vue?vue&type=template&id=2c06e0c3&scoped=true&"
import script from "./applicationList.vue?vue&type=script&lang=js&"
export * from "./applicationList.vue?vue&type=script&lang=js&"
import style0 from "./applicationList.vue?vue&type=style&index=0&id=2c06e0c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06e0c3",
  null
  
)

export default component.exports